var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdditionalWork = function SvgAdditionalWork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    strokeWidth: 1.5,
    viewBox: "4 4 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m7.5 7.83 3.375 3.375M7.5 7.83H5.25L4.5 5.58l.75-.75 2.25.75zm9.944-2.444-1.97 1.97c-.297.298-.446.446-.502.617a.75.75 0 0 0 0 .464c.056.171.205.32.502.617l.178.178c.297.297.445.445.616.5a.75.75 0 0 0 .464 0c.171-.055.32-.203.617-.5l1.843-1.844a4.125 4.125 0 0 1-4.62 5.614c-.364-.072-.547-.108-.657-.097a.6.6 0 0 0-.28.085c-.098.053-.196.15-.392.347l-5.368 5.368a1.591 1.591 0 0 1-2.25-2.25l5.368-5.368c.196-.196.294-.294.347-.392a.6.6 0 0 0 .085-.28c.01-.11-.025-.293-.097-.657a4.125 4.125 0 0 1 6.116-4.372M12 14.58l4.125 4.125a1.591 1.591 0 0 0 2.25-2.25l-3.393-3.393a4 4 0 0 1-.701-.129c-.292-.08-.612-.022-.826.192z"
  })));
};
export default SvgAdditionalWork;